import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import StudentGate from '@/components/StudentGate'
import FloatingAssistant from '@/components/floating-assistant/FloatingAssistant'
import RewardClaimReplayer from '@/features/rewards/RewardClaimReplayer'
import '@/styles/appShell.css'
import '@/styles/studentControls.css'

const Assessment = lazy(() => import('@/pages/assessment'))
const Classroom = lazy(() => import('@/pages/classroom'))
const CourseBrowser = lazy(() => import('@/pages/course-browser'))
const Dashboard = lazy(() => import('@/pages/redesign-home/RedesignHome'))
const Friends = lazy(() => import('@/pages/Friends'))
const LearningPath = lazy(() => import('@/pages/learning-path'))
const BonusGamePage = lazy(() => import('@/pages/learning-path/BonusGamePage'))
const WeekSchedule = lazy(() => import('@/pages/learning-path/WeekSchedule'))
const LanguageForest = lazy(() => import('@/pages/LanguageForest'))
const LessonPlayer = lazy(() => import('@/pages/lesson-player'))
const LessonChallenge = lazy(() => import('@/pages/lesson-challenge'))
const MyPage = lazy(() => import('@/pages/my'))
const AchievementsPage = lazy(() => import('@/pages/my/AchievementsPage'))
const ModesPage = lazy(() => import('@/pages/my/ModesPage'))
const AdventurePreview = lazy(() => import('@/pages/learning-games/AdventurePreview'))
const Phonics = lazy(() => import('@/pages/phonics'))
const Practice = lazy(() => import('@/pages/practice'))
const Pretest = lazy(() => import('@/pages/pretest'))
const Progress = lazy(() => import('@/pages/progress'))
const Reader = lazy(() => import('@/pages/reader'))
const StudentSelect = lazy(() => import('@/pages/student-select'))
const StudentManagement = lazy(() => import('@/pages/student-select/StudentManagement'))
const TodayPlan = lazy(() => import('@/pages/today-plan'))

function RouteLoading() {
  return (
    <div className="route-loading" role="status" aria-live="polite">
      <span className="route-loading-mark" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
      <span>正在整理学习档案</span>
    </div>
  )
}

export default function App() {
  return (
    <>
      <RewardClaimReplayer />
      <StudentGate>
        <Suspense fallback={<RouteLoading />}>
          <Routes>
            <Route path="/students" element={<StudentSelect />} />
            <Route path="/demo" element={<StudentSelect />} />
            <Route path="/students/manage" element={<StudentManagement />} />
            <Route path="/game-preview/adventure" element={<AdventurePreview />} />

            {/* AI Interactive Classroom (OpenMAIC-style) */}
            <Route path="/classroom" element={<Classroom />} />

            {/* / is the canonical student home; keep the legacy alias redirect-only. */}
            <Route path="/dashboard" element={<Navigate to="/" replace />} />

            {/* Main student experience */}
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/today-plan" element={<TodayPlan />} />
              <Route path="/pretest" element={<Pretest />} />
              <Route path="/learning-path" element={<LearningPath />} />
              <Route path="/learning-path/bonus" element={<BonusGamePage />} />
              <Route path="/learning-path/week-schedule" element={<WeekSchedule />} />
              <Route path="/language-forest" element={<LanguageForest />} />
              <Route path="/courses" element={<CourseBrowser />} />
              <Route path="/lesson/:unitId/:lessonNum" element={<LessonPlayer />} />
              <Route path="/lesson-challenge/:unitId/:lessonNum" element={<LessonChallenge />} />
              <Route path="/assessment" element={<Assessment />} />
              <Route path="/phonics" element={<Phonics />} />
              <Route path="/reader" element={<Reader />} />
              <Route path="/practice" element={<Practice />} />
              <Route path="/progress" element={<Progress />} />
              <Route path="/friends" element={<Friends />} />
              <Route path="/me" element={<MyPage />} />
              <Route path="/me/achievements" element={<AchievementsPage />} />
              <Route path="/me/modes" element={<ModesPage />} />
              <Route path="/me/*" element={<Navigate to="/me" replace />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
        <FloatingAssistant />
      </StudentGate>
    </>
  )
}
